// Runtime access to the site's static content. These JSON files are generated
// from content/ at build time (scripts/build-content.js) and served by the CDN
// like any other asset — there is no API server.

const cache = new Map();

// Resolves to parsed JSON, or null if the file is missing. (Vercel's SPA
// fallback answers unknown paths with index.html, so a non-JSON body also
// means "missing".) Failures aren't cached, so a later call can retry.
const getJson = (path) => {
    if (!cache.has(path)) {
        const request = fetch(path)
            .then((res) => (res.ok ? res.json() : null))
            .catch(() => null);
        cache.set(path, request);
        request.then((data) => { if (data == null) cache.delete(path); });
    }
    return cache.get(path);
};

// Post summaries (no body), newest first.
export const getBlogIndex = () => getJson('/data/blogs.json').then((d) => (Array.isArray(d) ? d : []));

// One full post by slug, or null.
export const getBlog = (slug) => getJson(`/data/blogs/${encodeURIComponent(slug)}.json`);

export const getReviews = () => getJson('/data/reviews.json').then((d) => (Array.isArray(d) ? d : []));
